import React from 'react';
import { createIcon } from './create-icon';
import './icon-view-options.scss';

export const IconViewOptions = createIcon(<div className="icon-view-options" />);
